import ActionTypes from "actions/action-types.js";
import { createAction } from "redux-actions";
const MOBILE_BREAKPOINT = 767;

var actions = {
  resize: createAction(ActionTypes.WINDOW_RESIZE),
  windowResize: function () {
    return function (dispatch) {
      var windowWidth = document.documentElement.clientWidth,
        isMobile = windowWidth < MOBILE_BREAKPOINT;

      dispatch(actions.resize(isMobile));
    };
  },
};

export default actions;

export const { resize, windowResize } = actions;
